import moment from 'moment';

export function isEventFinished(event) {
    const now = moment();
    return now.isAfter(event.end_local);
}
